import Enable2Fa from './enable-2fa'
import Enable2FaModal from './enable-2fa-modal'
import Disable2FaModal from './disable-2fa-modal'
import ChangePasswordModal from './change-password-modal'

export default [Enable2Fa, Enable2FaModal, Disable2FaModal, ChangePasswordModal]